import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useOrg } from '@/hooks/use-org';

export function useRequireAdmin() {
  const navigate = useNavigate();
  const { organizationId, currentOrg, isLoading, isPlatformOperatorView } = useOrg();
  const isAdmin = isPlatformOperatorView || currentOrg?.role === 'owner' || currentOrg?.role === 'admin';

  useEffect(() => {
    if (!isLoading && currentOrg && !isAdmin) void navigate({ to: '/' });
  }, [isLoading, currentOrg, isAdmin, navigate]);

  return { organizationId, isAdmin, isLoading: isLoading || (!!currentOrg && !isAdmin) };
}
